import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NOT_FOUND_ROUTE } from "@dtm-frontend/shared/utils";
import { MainPageContainerComponent } from "./components/main-page-container/main-page-container.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { PilotOperatorSearchComponent } from "./components/pilot-operator-search/pilot-operator-search.component";
import { CaaSubpageComponent } from "./components/subpages/caa-subpage/caa-subpage.component";
import { DroneTowerSubpageComponent } from "./components/subpages/drone-tower-subpage/drone-tower-subpage.component";
import { DssSubpageComponent } from "./components/subpages/dss-subpage/dss-subpage.component";
import { EIdentificationSubpageComponent } from "./components/subpages/e-identification-subpage/e-identification-subpage.component";
import { ELearningSubpageComponent } from "./components/subpages/e-learning-subpage/e-learning-subpage.component";
import { ERegistrationSubpageComponent } from "./components/subpages/e-registration-subpage/e-registration-subpage.component";
import { ESoraSubpageComponent } from "./components/subpages/e-sora-subpage/e-sora-subpage.component";
import { AboutProjectComponent } from "./components/subpages/kpo/about-project/about-project.component";
import { CompetitionComponent } from "./components/subpages/kpo/competition/competition.component";
import { ResultsComponent } from "./components/subpages/kpo/results/results.component";
import { MissionPlanningSubpageComponent } from "./components/subpages/mission-planning-subpage/mission-planning-subpage.component";
import { SahSubpageComponent } from "./components/subpages/sah-subpage/sah-subpage.component";
import { ThreeAreasSubpageComponent } from "./components/subpages/three-areas-subpage/three-areas-subpage.component";
import { WhereYouCanFlyComponent } from "./components/subpages/where-you-can-fly/where-you-can-fly.component";
import { SystemStateComponent } from "./components/system-state/system-state.component";

export const HIDE_BACKGROUND_IMAGE_ROUTE_DATA_KEY = "noBackgroundImage";

const routes: Routes = [
    {
        path: "",
        component: MainPageContainerComponent,
    },
    { path: "caa", component: CaaSubpageComponent },
    { path: "drone-tower", component: DroneTowerSubpageComponent },
    { path: "dss", component: DssSubpageComponent },
    { path: "e-registration", component: ERegistrationSubpageComponent },
    { path: "e-identification", component: EIdentificationSubpageComponent },
    { path: "e-learning", component: ELearningSubpageComponent },
    { path: "e-sora", component: ESoraSubpageComponent },
    { path: "mission-planning", component: MissionPlanningSubpageComponent },
    { path: "three-areas", component: ThreeAreasSubpageComponent },
    { path: "sah", component: SahSubpageComponent },
    // { path: "roadmap", component: RoadmapSubpageComponent }, // NOTE: Roadmap temporarily removed
    { path: "pilot-operator-search", component: PilotOperatorSearchComponent },
    { path: "system-state", component: SystemStateComponent },
    { path: "nrp/about-project", component: AboutProjectComponent },
    { path: "nrp/competition", component: CompetitionComponent },
    { path: "nrp/results", component: ResultsComponent },
    { path: "kpo", redirectTo: "nrp/about-project" },
    { path: "konkurs", redirectTo: "nrp/competition" },
    { path: "kpo/o-projekcie", redirectTo: "nrp/about-project" },
    { path: "kpo/konkurs", redirectTo: "nrp/competition" },
    { path: "kpo/wyniki", redirectTo: "nrp/results" },
    { path: "where-you-can-fly", component: WhereYouCanFlyComponent, data: { [HIDE_BACKGROUND_IMAGE_ROUTE_DATA_KEY]: true } },
    { path: NOT_FOUND_ROUTE, component: PageNotFoundComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MainPageLibRoutingModule {}
